// extracted by mini-css-extract-plugin
export default {"wrapper":"BetweenAccounts_wrapper__nFy-6","input":"BetweenAccounts_input__ugxUg"};